module.exports = __webpack_public_path__ + "static/media/girl4.7f75455b.svg";